export const dashboardTranslations = {
  en: {
    // Page Header
    badge: 'Welcome to Dashboard',
    title: 'Dashboard',
    subtitle: 'Your AI-Powered Workspace',
    
    // User Welcome Section
    welcome: 'Welcome',
    openChat: '💬 Open Chat',
    backToHome: 'Back to Home',
    logout: '🚪 Logout',
    loggingOut: 'Logging out...',
    
    // Contact Messages Section
    contactMessages: '📬 Contact Messages',
    newMessages: 'new',
    refresh: '🔄 Refresh',
    loading: '⏳ Loading...',
    loadingMessages: 'Loading messages...',
    noMessages: 'No messages yet 📭',
    
    // Message Status
    status: {
      new: 'new',
      read: 'read', 
      replied: 'replied'
    },
    
    // Message Details
    subject: '📋 Subject',
    message: '💬 Message',
    replyViaEmail: '📧 Reply via Email',
    
    // Regular User Content
    comingSoonTitle: '🚧 Dashboard Features Coming Soon...',
    comingSoonText: 'We\'re working on exciting features for you!',
    
    // Notifications
    newContactMessage: '📬 New Contact Message',
    notificationFrom: 'From',
    notificationSubject: 'Subject',
    
    // Academy Pricing Section
    academy: {
      pricing: {
        title: 'Academy Modules',
        free: { name: 'Start for Free' },
        single: { name: 'Pay Per Module' },
        full: { name: 'Full Program' },
        aiAgents: { name: 'AI Agents' },
        scaling: { name: 'Scaling & Growth' },
        designFlow: { name: 'Design Flow' },
        webScraping: { name: 'Web Scraping' }
      }
    },
    
    // Change Password Section
    changePassword: {
      title: '🔐 Change Password',
      subtitle: 'Update your account password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm new password',
      changeButton: 'Change Password',
      changing: 'Changing...',
      success: '✅ Password changed successfully!',
      error: '❌ Failed to change password',
      mismatch: 'Passwords do not match',
      tooShort: 'Password must be at least 6 characters',
      oauthUser: 'Password change is not available for social login accounts',
      cancel: 'Cancel'
    }
  },
  uk: {
    // Page Header
    badge: 'Ласкаво просимо в Dashboard',
    title: 'Панель керування',
    subtitle: 'Ваш робочий простір з ШІ',
    
    // User Welcome Section
    welcome: 'Ласкаво просимо',
    openChat: '💬 Відкрити чат',
    backToHome: 'Повернутися на головну',
    logout: '🚪 Вийти',
    loggingOut: 'Виходимо...',
    
    // Contact Messages Section
    contactMessages: '📬 Повідомлення клієнтів',
    newMessages: 'нових',
    refresh: '🔄 Оновити',
    loading: '⏳ Завантаження...',
    loadingMessages: 'Завантаження повідомлень...',
    noMessages: 'Поки немає повідомлень 📭',
    
    // Message Status
    status: {
      new: 'нове',
      read: 'прочитане',
      replied: 'відповіли'
    },
    
    // Message Details
    subject: '📋 Тема',
    message: '💬 Повідомлення',
    replyViaEmail: '📧 Відповісти електронною поштою',
    
    // Regular User Content
    comingSoonTitle: '🚧 Функції панелі керування незабаром...',
    comingSoonText: 'Ми працюємо над цікавими функціями для вас!',
    
    // Notifications
    newContactMessage: '📬 Нове повідомлення клієнта',
    notificationFrom: 'Від',
    notificationSubject: 'Тема',
    
    // Academy Pricing Section
    academy: {
      pricing: {
        title: 'Модулі Академії',
        free: { name: 'Почати безкоштовно' },
        single: { name: 'Оплата за модуль' },
        full: { name: 'Повна програма' },
        aiAgents: { name: 'ШІ Агенти' },
        scaling: { name: 'Масштабування та Ріст' },
        designFlow: { name: 'Дизайн-флоу' },
        webScraping: { name: 'Веб-скрапінг' }
      }
    },
    
    // Change Password Section
    changePassword: {
      title: '🔐 Змінити пароль',
      subtitle: 'Оновіть пароль вашого акаунту',
      currentPassword: 'Поточний пароль',
      newPassword: 'Новий пароль',
      confirmPassword: 'Підтвердіть новий пароль',
      changeButton: 'Змінити пароль',
      changing: 'Змінюємо...',
      success: '✅ Пароль успішно змінено!',
      error: '❌ Не вдалося змінити пароль',
      mismatch: 'Паролі не співпадають',
      tooShort: 'Пароль має бути не менше 6 символів',
      oauthUser: 'Зміна пароля недоступна для акаунтів з соціальним входом',
      cancel: 'Скасувати'
    }
  }
};